import React from "react";
import {Route, Routes} from "react-router-dom";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Equipment from "../pages/Equipment";
import WorkOrder from "../pages/WorkOrder";
import ManageChangeTip from "../container/workOrder/ManageChangeTip";
import ChangeRequestList from "../container/workOrder/ChangeRequestList";
import Document from "../pages/Document";
import Permission from "../pages/Permission";
import MyEval from "../container/education/Exam/MyEval";
import StartExam from "../container/education/Exam/StartExam";
import TakeExam from "../container/education/Exam/TakeExam";
import ExamResult from "../container/education/Exam/ExamResult";
import Archive from "../pages/Archive";
import Manual from "../container/manual/Manual";
import Post from "../pages/Post";
import ArchiveList from "../container/archive/ArchiveList";
import CreateFolder from "../container/archive/CreateFolder";
import UpdateFolder from "../container/archive/UpdateFolder";

const OfficerLevel = () => {
  return (
    <Routes>
      <Route path="Home/*" element={<Home />} />
      <Route path="Post/*" element={<Post />} />

      <Route path="Equipment/*" element={<Equipment />} />
      <Route path="WorkOrder/*" element={<WorkOrder />} />
      <Route path="WorkOrder/ManageChangeTip" element={<ManageChangeTip />} />
      <Route path="WorkOrder/ChangeRequestList" element={<ChangeRequestList />} />
      <Route path="Document/*" element={<Document />} />
      <Route path="Permission/*" element={<Permission />} />

      <Route path="Education/MyEval" element={<MyEval />} />
      <Route path="Education/StartExam/:id" element={<StartExam />} />
      <Route path="Education/TakeExam/:id" element={<TakeExam />} />
      <Route path="Education/ExamResult" element={<ExamResult />} />
      {/* <Route path="Archive/*" element={<Archive />} /> */}
      <Route path="Archive/" element={<ArchiveList />} />
      <Route path="Archive/:id" element={<ArchiveList />} />
      <Route path="Archive/Create/:id" element={<CreateFolder />} />
      <Route path="Archive/Edit/:id" element={<UpdateFolder />} />
      <Route path="Manual" element={<Manual />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default OfficerLevel;
